import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';
import { CheckmarkIcon, ExclamationmarkTriangleIcon, PadlockLockedIcon } from '@navikt/aksel-icons';
import { SurveyHeader } from './SurveyHeader';
import { SurveyMessage } from './SurveyMessage';
import classes from '../WorkEnvironmentFormSubmission.module.css';

export type ClosedReason = 'alreadyAnswered' | 'expired' | 'loadFailed';

const MESSAGES: Record<ClosedReason, Pick<Parameters<typeof SurveyMessage>[0], 'tone' | 'icon'>> = {
  alreadyAnswered: { tone: 'success', icon: <CheckmarkIcon aria-hidden /> },
  expired: { tone: 'neutral', icon: <PadlockLockedIcon aria-hidden /> },
  loadFailed: { tone: 'warning', icon: <ExclamationmarkTriangleIcon aria-hidden /> },
};

type Props = {
  reason: ClosedReason;
  onLanguageChange: (code: string) => void;
};

/** Why the employee cannot answer, on the same page as the survey */
export const SurveyClosed = ({ reason, onLanguageChange }: Props): ReactElement => {
  const { t } = useTranslation();
  return (
    <div className={classes.page} data-size="md">
      <SurveyHeader onLanguageChange={onLanguageChange} />
      <main className={classes.main}>
        <div aria-hidden="true" className={classes.backdrop} />
        <SurveyMessage {...MESSAGES[reason]} title={t(`workEnvironmentFormSubmission.${reason}.title`)}>
          <Paragraph data-size="lg" className={classes.subtle}>
            {t(`workEnvironmentFormSubmission.${reason}.description`)}
          </Paragraph>
        </SurveyMessage>
      </main>
    </div>
  );
};
